import watchWatchlistFlagRequested from './watchlistFlagSaga';

export default [
  watchWatchlistFlagRequested(),
];
